import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const userBooksSlice = createSlice({
  name: 'userBooks',
  initialState,
  reducers: {
    userBooksRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    userBooksSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    userBooksFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    userBooksReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const userBooksAction = userBooksSlice.actions;
export default userBooksSlice;